import React from 'react';
import { Modal, Button, Form, Input, Alert, Divider } from 'antd';

function AddWebSiteModal({ t, isOpen, toggle, onSubmit }) {
  return (
    <Modal
      className="add-site-modal upload-modal-content"
      visible={isOpen}
      onCancel={toggle}
      title={t('add-website')}
      footer={null}
    >
      <Form layout="vertical" onFinish={onSubmit}>
        <Form.Item
          className="upload-modal-content__item"
          name="url"
          label={t('link-address')}
          rules={[{ required: true, message: t('field-required') }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          className="upload-modal-content__item"
          name="name"
          label={t('name')}
          rules={[{ required: true, message: t('field-required') }]}
        >
          <Input />
        </Form.Item>
        {false && (
          <Alert
            className="upload-modal-content__alert"
            message={t('link-allow-access')}
            type="error"
          />
        )}
        <Divider className="upload-modal-content__divider" />
        <div className="upload-modal-content__actions">
          <Button htmlType="button" onClick={toggle}>
            {t('cancel')}
          </Button>
          <Button htmlType="submit" type="primary">
            {t('add-website')}
          </Button>
        </div>
      </Form>
    </Modal>
  );
}

export default AddWebSiteModal;
